import { DetailedVehicleInfoProps } from '../../../../components/PageWrappers/AdDetails/DetailedVehicleInfo/DetailedVehicleInfo.typed';
import { Accordion } from '../../../../components/ToolkitV2/Accordion/Accordion';
import { useAccordion } from '../../../../components/ToolkitV2/Accordion/useAccordion';
import { FeatureList } from '../../../../components/PageWrappers/AdDetails/components/FeatureListGrid/FeatureList/FeatureList';
import { KeyInfoList } from '../../../../components/Toolkit/KeyInfoList/KeyInfoList';
import * as Styled from '../../../../components/PageWrappers/AdDetails/DetailedVehicleInfo/DetailedVehicleInfo.styled';

const DetailedVehicleInfo = (props: DetailedVehicleInfoProps) => {
  const { structuredAttributes, vehicleFeatures } = props;
  const { checkIsOpen, onChange } = useAccordion({
    isAlwaysOpen: true,
    initialOpenIds: ['panel0'],
  });

  const hasOnlyVehicleOverview =
    structuredAttributes.length === 1 &&
    structuredAttributes[0].name === 'overview';

  const renderVehicleOverviewOnly = !vehicleFeatures && hasOnlyVehicleOverview;

  if (renderVehicleOverviewOnly) {
    return (
      <>
        <Styled.Header title={structuredAttributes[0].displayName} />
        <KeyInfoList infoList={structuredAttributes[0].values} />
      </>
    );
  }

  return (
    <>
      {structuredAttributes.map((attributes, index) => {
        const hasVehicleFeatures =
          vehicleFeatures && vehicleFeatures?.length > 0;

        const showDivider = hasVehicleFeatures
          ? true
          : index !== structuredAttributes.length - 1;

        return (
          <Accordion
            key={index}
            isOpen={checkIsOpen(`panel${index}`)}
            onChange={() => onChange(`panel${index}`)}
            header={attributes.displayName}
            content={
              <Styled.KeyInfoWrapper>
                <KeyInfoList infoList={attributes.values} />
              </Styled.KeyInfoWrapper>
            }
            showDivider={showDivider}
            dataTracking={`detailed-vehicle-info-${attributes.name}-panel`}
          />
        );
      })}

      {vehicleFeatures && vehicleFeatures?.length > 0 && (
        <Accordion
          header="Features"
          content={
            <Styled.FeaturesContainer>
              {vehicleFeatures?.map((feature, index) => {
                return (
                  <FeatureList key={index} title={feature.category}>
                    {feature.features.map((feature, index) => (
                      <span key={index}>{feature}</span>
                    ))}
                  </FeatureList>
                );
              })}
            </Styled.FeaturesContainer>
          }
          isOpen={checkIsOpen('features')}
          onChange={() => onChange('features')}
          showDivider={false}
          dataTracking={`detailed-vehicle-info-features-panel`}
        />
      )}
    </>
  );
};

export { DetailedVehicleInfo };
